import { useTranslation } from 'next-i18next'

import { LearningProduct } from '~/MathTopics/types/math-topic.type'

interface Props {
  item: LearningProduct
}

export default function BootcampModules(props: Props): React.ReactElement {
  const { t } = useTranslation('mathTopics')

  const { item } = props

  return (
    <div className="flex flex-col items-center justify-center h-28 px-2 pt-2 pb-4 text-center">
      <div className="h-5 mb-2 last:mb-0 font-semibold leading-4 tracking-widest">
        {item.courseCount} {item.courseCount === 1 ? t('course') : t('courses')}
      </div>
      <div className="h-5 mb-2 last:mb-0 font-normal leading-4 tracking-widest">
        {item.videoCount} {item.videoCount === 1 ? t('video') : t('videos')}
      </div>
      <div className="h-5 mb-2 last:mb-0 font-normal leading-4 tracking-widest">
        {item.activityCount} {item.activityCount === 1 ? t('activitySet') : t('activitySets')}
      </div>
    </div>
  )
}
